import { Signup, SignupDto } from '../types/signup'

export function mapSignupToDto(data: Signup): SignupDto {
  return {
    firstname: data.firstname,
    lastname: data.lastname,
    email: data.email,
    phone: data.phone,
    password: data.password,
    repeat_password: data.repeatPassword,
    utm: {
      campaign: data.utm?.campaign || null,
      source: data.utm?.source || null,
      medium: data.utm?.medium || null,
    },
  }
}
